<template>
  <calc-form-item title-style="inline">
    <template slot="title">
      {{ $t("Fibra superior") }}
      <app-tooltip class="m-pad-0">
        <img
          style="width: 300px"
          src="@/assets/img/fibra_superior_e_inferior.jpg"
        />
      </app-tooltip>
    </template>

    <b-radio-group>
      <b-radio :native-value="false" v-model="useUpperFibre">{{
        $t("Fibra superior contraventada pelo painel/chapa")
      }}</b-radio>
      <b-radio :native-value="true" v-model="useUpperFibre">{{
        $t("Número de travamentos laterais")
      }}</b-radio>
    </b-radio-group>

    <transition name="anim-slideX">
      <calc-form-unit-fibre-span-cfg
        ref="calcFormUnitFibreSpanCfg"
        v-if="useUpperFibre"
        v-model="upperFibre"
      />
    </transition>
  </calc-form-item>
</template>

<script>
import { mapState } from "vuex";
import { withoutDuplicates } from "@/utils";
import CalcFormUnitFibreSpanCfg from "./CalcFormUnitFibreSpanCfg";

export default {
  components: {
    CalcFormUnitFibreSpanCfg,
  },

  data() {
    return {
      useUpperFibre: undefined,
      unwatchUseUpperFibre: undefined,
    };
  },

  computed: {
    ...mapState("calculator", ["calculation"]),

    upperFibre: {
      get() {
        return this.calculation.input.spanRestraints.upperFibre;
      },
      set(val) {
        this.calculation.input.spanRestraints.upperFibre = val;
      },
    },
  },

  activated() {
    if (this.useUpperFibre !== true) {
      this.useUpperFibre = !(
        withoutDuplicates(this.upperFibre).length === 1 &&
        this.upperFibre[0] === -1
      );
    }

    //we only want to start watching after we set it's initial value
    this.unwatchUseUpperFibre = this.$watch(
      "useUpperFibre",
      (useUpperFibre) => {
        if (useUpperFibre) {
          this.upperFibre = Array(this.upperFibre.length).fill(0);
        } else {
          this.upperFibre = Array(this.upperFibre.length).fill(-1);
        }
      }
    );
  },

  deactivated() {
    this.unwatchUseUpperFibre();
  },
};
</script>

<style lang="scss" scoped></style>
